import React from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { image } from 'services'
import { isObject } from 'app/services/object'
import { colors } from 'theme'

import { Divider } from 'components'
import { Button, ProgressRing } from 'controls'

import Recommendation from './Recommendation'

import {
  formatScoreHealth,
  progressHealth,
  getConstantRange
} from './helper'

import styles from './styles'

const WellnessCard = ({
  propertyId,
  healthProperty,
  attr,
  cardImage,
  title,
  scoreInfo,
  scoreColor,
  recommendation,
  buttons,
  icons
}) => {
  const rangeScore = getConstantRange(progressHealth(healthProperty, attr))

  return (
    <div
      className={classnames('card-container', {
        [rangeScore]: isObject(recommendation) || ''
      })}
    >
      <div className="card-score">
        <ProgressRing
          progress={progressHealth(healthProperty, attr)}
          size={70}
          strokeWidth={5}
          circleOneStroke=""
          circleTwoStroke={scoreColor[rangeScore].color}
          fillBgCircle={colors.alpha(scoreColor[rangeScore].color, 0.2)}
          imageUrl={cardImage}
        />
        <div className="score">
          <span className="score__title">{title}</span>
          <span className="score__score">
            {formatScoreHealth(healthProperty, attr)}
          </span>
          <span className="score__info">{scoreInfo}</span>
        </div>
      </div>
      <Divider
        style={{
          marginBottom: '0',
          width: '15%',
          borderBottom: `solid ${scoreColor[rangeScore].color} 2px`
        }}
      />
      <div className="card-recommendation">
        <Recommendation
          recommendation={recommendation}
          rangeScore={rangeScore}
        />
      </div>
      {buttons.length > 0 && (
        <div className="card-buttons">
          {buttons.map(({ buttonName, as, href }, index) => (
            <Button
              key={index}
              size="medium"
              color="primary"
              outline
              as={as(propertyId)}
              href={href(propertyId)}
            >
              {buttonName}
            </Button>
          ))}
        </div>
      )}

      {icons.length > 0 && (
        <div className="card-icons">
          {icons.map((icon, index) => (
            <img className="card-icon" key={index} src={image(icon)} />
          ))}
        </div>
      )}

      <style jsx>{styles}</style>
    </div>
  )
}

WellnessCard.propTypes = {
  propertyId: PropTypes.number.isRequired,
  healthProperty: PropTypes.object.isRequired,
  attr: PropTypes.string.isRequired,
  cardImage: PropTypes.string,
  title: PropTypes.string,
  scoreInfo: PropTypes.string,
  scoreColor: PropTypes.object,
  recommendation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      buttonName: PropTypes.string,
      as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      href: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
    })
  ),
  icons: PropTypes.arrayOf(PropTypes.string)
}

export default WellnessCard
